import React from 'react';
import { useBooking, Branch } from '../context/BookingContext';
import { ArrowRightIcon, PhoneIcon, ClockIcon, MapPinIcon } from 'lucide-react';
export const BranchSelection = () => {
  const {
    booking,
    setBooking,
    nextStep
  } = useBooking();
  const branches: Branch[] = [{
    id: '1',
    name: 'Aneeq Salon Downtown',
    address: '123 Beauty Street, New York, NY 10001',
    phone: '(212) 555-1234',
    hours: 'Mon-Sat: 9AM-7PM, Sun: 10AM-5PM',
    location: [40.7128, -74.006],
    image: 'https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
  }, {
    id: '2',
    name: 'Aneeq Salon Uptown',
    address: '456 Fashion Avenue, New York, NY 10028',
    phone: '(212) 555-5678',
    hours: 'Mon-Sat: 9AM-8PM, Sun: 10AM-6PM',
    location: [40.7831, -73.9712],
    image: 'https://images.unsplash.com/photo-1470259078422-826894b933aa?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
  }, {
    id: '3',
    name: 'Aneeq Salon Brooklyn',
    address: '789 Style Street, Brooklyn, NY 11201',
    phone: '(718) 555-9012',
    hours: 'Mon-Sat: 10AM-8PM, Sun: 11AM-6PM',
    location: [40.6782, -73.9442],
    image: 'https://images.unsplash.com/photo-1600948836101-f9ffda59d250?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
  }];
  const handleSelectBranch = (branch: Branch) => {
    setBooking(prev => ({
      ...prev,
      branch
    }));
  };
  const handleContinue = () => {
    if (booking.branch) {
      nextStep();
    }
  };
  return <div data-id="element-92">
      <h3 className="text-xl font-medium text-[#D6B88E] mb-4" data-id="element-93">
        Select a Salon Location
      </h3>
      <div className="grid grid-cols-1 gap-6 mb-8" data-id="element-94">
        {branches.map(branch => <div key={branch.id} className={`border rounded-lg overflow-hidden cursor-pointer transition-all hover:shadow-lg ${booking.branch?.id === branch.id ? 'border-[#D6B88E] ring-2 ring-[#D6B88E]/30 bg-[#2A1E1E]/50' : 'border-[#3B2A2A] bg-[#2A1E1E]/20'}`} onClick={() => handleSelectBranch(branch)} data-id="element-95">
            <div className="flex flex-col md:flex-row" data-id="element-96">
              <div className="md:w-1/3 h-48 md:h-auto overflow-hidden" data-id="element-97">
                <img src={branch.image} alt={branch.name} className="w-full h-full object-cover" data-id="element-98" />
              </div>
              <div className="p-5 md:w-2/3 flex flex-col justify-between" data-id="element-99">
                <div data-id="element-100">
                  <div className="flex items-center mb-3" data-id="element-101">
                    <h4 className="text-xl font-medium text-[#D6B88E]" data-id="element-102">
                      {branch.name}
                    </h4>
                    {booking.branch?.id === branch.id && <span className="ml-3 px-2 py-1 text-xs bg-[#D6B88E] text-[#2A1E1E] rounded-full" data-id="element-103">
                        Selected
                      </span>}
                  </div>
                  <div className="space-y-3 text-sm mb-4" data-id="element-104">
                    <p className="text-[#E7D7BC] flex items-start" data-id="element-105">
                      <MapPinIcon className="w-4 h-4 mr-2 mt-1 flex-shrink-0 text-[#D6B88E]" data-id="element-106" />
                      <span data-id="element-107">{branch.address}</span>
                    </p>
                    <p className="text-[#E7D7BC] flex items-start" data-id="element-108">
                      <PhoneIcon className="w-4 h-4 mr-2 mt-1 flex-shrink-0 text-[#D6B88E]" data-id="element-109" />
                      <span data-id="element-110">{branch.phone}</span>
                    </p>
                    <p className="text-[#E7D7BC] flex items-start" data-id="element-111">
                      <ClockIcon className="w-4 h-4 mr-2 mt-1 flex-shrink-0 text-[#D6B88E]" data-id="element-112" />
                      <span data-id="element-113">{branch.hours}</span>
                    </p>
                  </div>
                </div>
                <button className={`self-start mt-2 flex items-center gap-1 px-4 py-2 rounded-md transition-colors ${booking.branch?.id === branch.id ? 'bg-[#D6B88E] text-[#2A1E1E] hover:bg-[#E7D7BC]' : 'bg-[#3B2A2A] text-[#E7D7BC] hover:bg-[#4A3A3A]'}`} onClick={e => {
              e.stopPropagation();
              handleSelectBranch(branch);
              if (booking.branch?.id !== branch.id) {
                setTimeout(() => handleContinue(), 300);
              } else {
                handleContinue();
              }
            }} data-id="element-114">
                  {booking.branch?.id === branch.id ? 'Selected' : 'Select'}{' '}
                  <ArrowRightIcon className="w-4 h-4" data-id="element-115" />
                </button>
              </div>
            </div>
          </div>)}
      </div>
      <div className="flex justify-end" data-id="element-116">
        <button onClick={handleContinue} className={`flex items-center gap-1 px-6 py-2 rounded-md transition-colors ${booking.branch ? 'bg-[#D6B88E] text-[#2A1E1E] hover:bg-[#E7D7BC]' : 'bg-[#3B2A2A] text-[#8A7A6A] cursor-not-allowed'}`} disabled={!booking.branch} data-id="element-117">
          Continue <ArrowRightIcon className="w-4 h-4" data-id="element-118" />
        </button>
      </div>
    </div>;
};